import { IonSpinner } from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { GlobalContext } from "../../../global/context/Provider";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Modal from "../../components/Genericos/Modal/Modal";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import { estudioGrupo } from "../../context/Actions/estudioGrupo/estudioGrupo";
import { laboGrupo } from "../../context/Actions/laboGrupo/laboGrupo";
import { PortalContext } from "../../context/Provider";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import "./Home.css";

const Home = () => {
  const {
    modalState,
    estudioGrupoDispatch,
    estudioGrupoState,
    laboGrupoState,
    laboGrupoDispatch,
  } = useContext(PortalContext);

  const { toasterState } = useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data === null) {
      estudioGrupo()(estudioGrupoDispatch);
    }
    if (laboGrupoState.laboGrupo.data === null) {
      laboGrupo()(laboGrupoDispatch);
    }
  }, []);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      {!estudioGrupoState.estudioGrupo.data && (
        <div className="ptur-home-loading">
          <IonSpinner name="lines" />
        </div>
      )}

      {estudioGrupoState.estudioGrupo.data && (
        <div className="ptur-bodyContainer-Home">
          {/* <Sidebar/> */}
          <div className="ptur-container bgc-white">
            <TituloSaludo />
          </div>
        </div>
      )}

      {/* <FooterBar /> */}
    </React.Fragment>
  );
};
export default Home;
